import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = ["id", "name"]
const _hoisted_4 = {
  key: 0,
  class: "ml-1 text-sm"
}

import { computed, useSlots, withDefaults } from 'vue';
import { getUniqueId } from '@/util/helpers/unique-id';

interface Props {
    modelValue: string | number | boolean;
    id?: string;
    label?: string;
    name?: string;
    trueValue?: string | number | boolean;
    falseValue?: string | number | boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomCheckbox',
  props: {
    modelValue: { type: [String, Number, Boolean] },
    id: { default: '' },
    label: { default: '' },
    name: { default: undefined },
    trueValue: { type: [String, Number, Boolean], default: true },
    falseValue: { type: [String, Number, Boolean], default: false }
  },
  setup(__props: any, { emit }: { emit: ({
    'update:modelValue': [value: string | number | boolean];
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: string | number | boolean, id: string, label: string, name: string, trueValue: string | number | boolean, falseValue: string | number | boolean }



const slots = useSlots();

const computedModelValue = computed({
    get() {
        return props.modelValue === props.trueValue;
    },
    set(value: boolean) {
        const newValue = value ? props.trueValue : props.falseValue;

        emit('update:modelValue', newValue);
    },
});
const inputId = computed(() => props.id || `ui-checkbox-${getUniqueId()}`);
const hasLabel = computed(() => Boolean(props.label || slots.label));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    for: _unref(inputId),
    class: "relative flex items-center"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        id: _unref(inputId),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(computedModelValue) ? (computedModelValue).value = $event : null)),
        name: __props.name,
        type: "checkbox",
        class: "!mt-auto !bg-none"
      }, null, 8, _hoisted_3), [
        [_vModelCheckbox, _unref(computedModelValue)]
      ])
    ]),
    (_unref(hasLabel))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "label", { label: __props.label }, () => [
            _createTextVNode(_toDisplayString(__props.label), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})